import React, { useState, useEffect, useCallback } from 'react';
import '../shared.css';
import Sidebar from '../Components/Layout/sidebar';
import Topbar from '../Components/Layout/topbar';
import Button from '../Components/Comman/Button';
import Analytic_cards from '../Components/Comman/Analytics_card';
import Modal from '../Components/Comman/Modal';
import {
  FieldGroup, TextInput, SelectInput, FormGrid, FormActions, DeleteConfirm,
} from '../Components/Comman/FormFields';
import { supabase } from '../supabaseClient';

/* Actual DB columns: id, company_name, description, category,
   logo_url, contact_email, contact_phone, is_featured, created_at */

const CATEGORIES = ['Fine Art', 'Handicrafts', 'Photography', 'Prints & Posters', 'Ceramics', 'Textile Art', 'Sculpture', 'Mixed Media', 'Other'];
const FEATURED_OPTIONS = ['Yes', 'No'];

const blank = () => ({
  company_name: '', description: '', category: '',
  logo_url: '', contact_email: '', contact_phone: '', is_featured: 'No',
});

/* ── Card ── */
const ExhibitorCard = ({ company_name, category, contact_email, contact_phone, is_featured, description, onEdit, onDelete }) => {
  const featured = is_featured === 'Yes' || is_featured === true;
  return (
    <div style={{
      background: 'rgba(245,240,232,0.7)', borderRadius: 8, padding: '18px 20px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      border: '1px solid rgba(42,42,42,0.08)',
      transition: 'transform 0.18s ease, box-shadow 0.18s ease',
    }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.1)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <div style={{
          width: 42, height: 42, borderRadius: 8, background: '#D6B893',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: '"Cormorant Garamond"', fontSize: 20, fontWeight: 700, color: '#0D0D0D',
        }}>{(company_name || '?')[0].toUpperCase()}</div>
        <div>
          <p style={{ fontFamily: '"Cormorant Garamond"', fontSize: 17, fontWeight: 600, color: '#191919' }}>{company_name}</p>
          <p style={{ fontFamily: 'Inter', fontSize: 12, color: '#8B8B7A' }}>{category}{description ? ` · ${description}` : ''}</p>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
        <p style={{ fontFamily: 'Inter', fontSize: 12, color: '#8B8B7A' }}>{contact_email}</p>
        {featured && (
          <span style={{
            fontFamily: 'Inter', fontSize: 11.5, fontWeight: 600,
            padding: '3px 10px', borderRadius: 99,
            background: 'rgba(74,148,74,0.14)', color: '#2d7a2d',
          }}>Featured</span>
        )}
        <button type="button" onClick={onEdit}
          style={{ background: 'none', border: '0.762px solid rgba(42,42,42,0.2)', borderRadius: 5, padding: '5px 12px', fontFamily: 'Inter', fontSize: 11.5, cursor: 'pointer', color: '#191919', transition: 'background 0.15s' }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(214,184,147,0.3)'}
          onMouseLeave={e => e.currentTarget.style.background = 'none'}
        >Edit</button>
        <button type="button" onClick={onDelete}
          style={{ background: 'rgba(180,60,60,0.07)', border: '0.762px solid rgba(180,60,60,0.2)', borderRadius: 5, padding: '5px 12px', fontFamily: 'Inter', fontSize: 11.5, cursor: 'pointer', color: '#a33', transition: 'background 0.15s' }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(180,60,60,0.15)'}
          onMouseLeave={e => e.currentTarget.style.background = 'rgba(180,60,60,0.07)'}
        >Delete</button>
      </div>
    </div>
  );
};

/* ── Form ── */
const ExhibitorForm = ({ initial, onSave, onCancel, loading }) => {
  const [form, setForm] = useState(initial || blank());
  useEffect(() => { setForm(initial || blank()); }, [initial]);
  const set = (key) => (val) => setForm(f => ({ ...f, [key]: val }));
  const handleSubmit = (e) => { e.preventDefault(); onSave(form); };

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <FormGrid>
          <FieldGroup label="Company Name" required>
            <TextInput value={form.company_name} onChange={set('company_name')} placeholder="Gallery / Studio name" required />
          </FieldGroup>
          <FieldGroup label="Category" required>
            <SelectInput value={form.category} onChange={set('category')} options={CATEGORIES} required />
          </FieldGroup>
          <FieldGroup label="Contact Email" required>
            <TextInput value={form.contact_email} onChange={set('contact_email')} type="email" placeholder="contact@example.com" required />
          </FieldGroup>
          <FieldGroup label="Contact Phone">
            <TextInput value={form.contact_phone} onChange={set('contact_phone')} placeholder="+20 100 000 0000" />
          </FieldGroup>
          <FieldGroup label="Logo URL">
            <TextInput value={form.logo_url} onChange={set('logo_url')} placeholder="https://..." />
          </FieldGroup>
          <FieldGroup label="Featured">
            <SelectInput value={form.is_featured} onChange={set('is_featured')} options={FEATURED_OPTIONS} />
          </FieldGroup>
        </FormGrid>
        <FieldGroup label="Description">
          <TextInput value={form.description} onChange={set('description')} placeholder="Short description of the exhibitor" />
        </FieldGroup>
        <FormActions onCancel={onCancel} submitLabel={initial?.id ? 'Update Exhibitor' : 'Add Exhibitor'} loading={loading} />
      </div>
    </form>
  );
};

/* ── Page ── */
const Exhibitors = () => {
  const [exhibitors, setExhibitors] = useState([]);
  const [loading, setLoading]       = useState(false);
  const [saving, setSaving]         = useState(false);
  const [search, setSearch]         = useState('');
  const [modal, setModal]           = useState(null);
  const [selected, setSelected]     = useState(null);
  const [toast, setToast]           = useState(null);

  const showToast = (msg, isError = false) => {
    setToast({ msg, isError });
    setTimeout(() => setToast(null), 3500);
  };

  const fetchExhibitors = useCallback(async () => {
    setLoading(true);
    const { data, error } = await supabase.from('exhibitors').select('*').order('company_name');
    if (error) showToast('Failed to load: ' + error.message, true);
    else setExhibitors(data || []);
    setLoading(false);
  }, []);

  useEffect(() => { fetchExhibitors(); }, [fetchExhibitors]);

  const filtered = exhibitors.filter(e =>
    (e.company_name  || '').toLowerCase().includes(search.toLowerCase()) ||
    (e.category      || '').toLowerCase().includes(search.toLowerCase()) ||
    (e.contact_email || '').toLowerCase().includes(search.toLowerCase())
  );

  const handleCreate = async (form) => {
    setSaving(true);
    const payload = { ...form };
    delete payload.id;
    const { error } = await supabase.from('exhibitors').insert([payload]);
    setSaving(false);
    if (error) { showToast(error.message, true); return; }
    showToast('Exhibitor added ✓');
    setModal(null);
    fetchExhibitors();
  };

  const handleUpdate = async (form) => {
    setSaving(true);
    const { id, created_at, ...rest } = form;
    const { error } = await supabase.from('exhibitors').update(rest).eq('id', id);
    setSaving(false);
    if (error) { showToast(error.message, true); return; }
    showToast('Exhibitor updated ✓');
    setModal(null);
    fetchExhibitors();
  };

  const handleDelete = async () => {
    setSaving(true);
    const { error } = await supabase.from('exhibitors').delete().eq('id', selected.id);
    setSaving(false);
    if (error) { showToast(error.message, true); return; }
    showToast('Exhibitor deleted ✓');
    setModal(null);
    fetchExhibitors();
  };

  const closeModal = () => { setModal(null); setSelected(null); };
  const featured   = exhibitors.filter(e => e.is_featured === 'Yes' || e.is_featured === true);

  return (
    <main>
      <Sidebar />
      <div className='pagestrcutre'>
        <Topbar />

        {toast && (
          <div style={{ position: 'fixed', top: 24, right: 24, zIndex: 99999, background: toast.isError ? '#a33' : '#2d7a2d', color: '#fff', padding: '12px 20px', borderRadius: 8, fontFamily: 'Inter', fontSize: 13, boxShadow: '0 6px 20px rgba(0,0,0,0.2)' }}>{toast.msg}</div>
        )}

        <div className='pagetop_div'>
          <div className='pagetop_div1'>
            <h3 className='pagetop_text1'>Exhibitors</h3>
            <Button text='+ Add Exhibitor' icon={null} onClick={() => { setSelected(null); setModal('create'); }} />
          </div>
          <p className='pagetop_text2'>Manage all exhibition participants</p>
        </div>

        <div className='analytics_div'>
          <Analytic_cards text1='Total Exhibitors' text2={exhibitors.length}  text3='Registered' />
          <Analytic_cards text1='Featured'         text2={featured.length}    text3='Highlighted exhibitors' />
          <Analytic_cards text1='Categories'       text2={[...new Set(exhibitors.map(e => e.category).filter(Boolean))].length} text3='Unique categories' />
        </div>

        <div className='page_content' style={{ paddingBottom: 30 }}>
          <div style={{ position: 'relative', marginBottom: 16 }}>
            <svg style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', width: 16, height: 16, color: 'rgba(13,13,13,0.45)', pointerEvents: 'none' }} viewBox='0 0 20 20' fill='none'>
              <circle cx='9' cy='9' r='6' stroke='currentColor' strokeWidth='1.6'/>
              <path d='M14 14l3 3' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round'/>
            </svg>
            <input
              style={{ width: '100%', height: 34, padding: '6px 12px 6px 34px', borderRadius: 6, border: '0.762px solid rgba(42,42,42,0.2)', background: '#F5F0E8', fontFamily: 'Inter', fontSize: 12.5, outline: 'none', color: '#0D0D0D', boxSizing: 'border-box' }}
              placeholder='Search exhibitors…'
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          {loading ? (
            <p style={{ fontFamily: 'Inter', fontSize: 13, color: '#8B8B7A', padding: 20 }}>Loading…</p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {filtered.map(e => (
                <ExhibitorCard key={e.id} {...e}
                  onEdit={() => { setSelected(e); setModal('edit'); }}
                  onDelete={() => { setSelected(e); setModal('delete'); }}
                />
              ))}
              {filtered.length === 0 && (
                <p style={{ textAlign: 'center', padding: 48, fontFamily: '"Cormorant Garamond"', fontSize: 16, fontStyle: 'italic', color: 'rgba(13,13,13,0.4)' }}>No exhibitors found.</p>
              )}
            </div>
          )}
        </div>

        <Modal open={modal === 'create'} onClose={closeModal} title="Add Exhibitor">
          <ExhibitorForm onSave={handleCreate} onCancel={closeModal} loading={saving} />
        </Modal>
        <Modal open={modal === 'edit'} onClose={closeModal} title="Edit Exhibitor">
          <ExhibitorForm initial={selected} onSave={handleUpdate} onCancel={closeModal} loading={saving} />
        </Modal>
        <Modal open={modal === 'delete'} onClose={closeModal} title="Delete Exhibitor" width={420}>
          <DeleteConfirm label={selected?.company_name} onConfirm={handleDelete} onCancel={closeModal} loading={saving} />
        </Modal>
      </div>
    </main>
  );
};

export default Exhibitors;